<!-- <div class="ai-landing-page">
    <div class="ai-landing-page-desc">
        <div class="ai-mygooru-img"><img class="ai-gooru-icon" src="/assets/images/mygooru-image.svg" /></div>
        <div class="ai-gps-head-content">
            <span class="ai-gps-head-content1">My</span>
            <span class="ai-gps-head-content2">Gooru - </span>
            <span class="ai-gps-head-content3">a GPS for Learning</span>
        </div>
        <div class="ai-google-map-desc">
            Gooru has developed <a class="ai-learner-video" href="https://www.youtube.com/watch?v=jjSiUx994wc" target="_blank">MyGooru LearnBot</a> that brings AI-based personalization to 3rd party applications.
            MyGooru LearnBot can be added to any eLearning Solution Provider’s application to personalize
            learning for their users with their content. It starts with an understanding of the learner and 
            navigates the learner to their learning goals with personalized learning pathways. MyGooru 
            continuously updates its understanding of the learner, provides nudges based on learner's
             performance and answers learner's questions. MyGooru ensures that learners always reach their learning goals. 
        </div>
        <div class="ai-langing-page-head-img"><img class="ai-system-icon" src="/assets/images/marketing-image.png" /></div>
        <div class="ai-experience-title">
            Experience MyGooru’s capabilities here 
        </div>
        <div class="ai-learn-bot-desc">
            Learners can explore topics of interest and MyGooru will navigate them with recommendations of learning resources, nudges, and answers to their questions on the topic. Learners can ask for pathways and get a personalized route with learning activities that guides them to their destination.
        </div>
        <div class="ai-learn-bot-desc">
            Depending on whether you are studying in K12 or HigherEd or a working professional, choose topics from core subjects such as Math, Science, and English, or topics related to statistics, communication, POSH, and others. If you are a teacher, you can explore topics in educational leadership or competency-based education, 
        </div>
        <div class="ai-learn-bot-desc">
            As an instructor, you can also experience how MyGooru provides insights about the students in your class, or get nudges based on performance of your cohort of learners, and tools to help improve your productivity. 
        </div>
        <div class="ai-learn-bot-desc">
            Start by entering the code that has been shared with you and explore MyGooru. We would love to hear from you about your experience. Please write to us at <a class="ai-learner-mail" href="mailto:mygooru@goorulearning.com" target="_blank">mygooru&#64;goorulearning.com</a>
        </div>
    </div>
</div> -->
<div class="ai-loader-gif-head" *ngIf="!isExplorePage">
    <img class="ai-loader-gif" alt="loader image" appPrependUrl src="/assets/images/loader.gif">
    <span class="ai-loader-text">Initializing your MyGooru experience...</span>
</div>
<div class="myg-loader-b2b" *ngIf="isExplorePage">
    <div class="myg-logo-container">
      <img
        appPrependUrl
        src="/assets/images/gooru-chat-logo.svg"
        alt="MyGooru Logo"
        class="myg-logo"
      />
      <h2 class="myg-logo-header">a GPS for Learning</h2>
    </div>
  <div class="myg-welcome-msg-container">
    <div class="myg-welcome-heading">Welcome to MyGooru</div>
    <div class="myg-welcome-message">
      MyGooru is a GPS for Learning that focuses on you, and personalizes the
      learning journey for you
    </div>
  </div>
  <div class="ai-loader-gif-head">
    <img
      class="ai-loader-gif"
      alt="loader image"
      appPrependUrl
      src="/assets/images/loader.gif"
    />
  </div>
  <div class="myg-message-container">
    <div class="fade-in" *ngIf="currentStep === 1">
      <div class="myg-moment-msg-container">
        <div class="myg-moment-message-first">
          Just a moment... we’re mapping your
        </div>
        <div class="myg-moment-message-second">personalized learning path.</div>
      </div>
    </div>
    <div class="fade-in" *ngIf="currentStep === 2">
      <div class="myg-mygooru-initialize-container">
        Initialising MyGooru<span class="dots"></span>
      </div>
    </div>
    <div class="fade-in" *ngIf="currentStep === 3">
      <div class="myg-analyzing-message-container">
        <div class="myg-analyzing-message">Analyzing Your Query<span class="dots"></span></div>
      </div>
    </div>
  </div>
</div>
